/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateCurrentPage } from 'state/slices/app'
// material
import { SectionGroupV2 } from 'material/expandablesection/v2'
import { Button, InlineMessage } from '@insticator/insticator-ui'
import { url } from 'utils/urls'
import PreviewConfig from '../../previewconfig/previewconfig'
import Space from 'material/space/space'
import { ReactComponent as WarningIcon } from 'assets/icons/error-circle.svg'
// styles
import injectSheet from 'react-jss'
import styles from './genderoptions_styles'


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: ADVANCED SECTION : LOGIN AUTHENTICATION ~~~~~~~~~~ ========== */
const GenderOptions = injectSheet(styles)((props) => {
  const dispatch = useDispatch()

  const mocked = useSelector(state => state.session.mocked);

  return (
    <SectionGroupV2 
      klass={`genderoptions ${props.classes.genderoptions}`}
      title={'Gender Options'} 
      description={`
        Manage the gender options available for selection on a users profile.
      `}
      indented
    >
      <div className='explainer'>
        { mocked ?
          <Button
            klass={'configbutton'}
            variant={'neutral'}
            text={'Configure'}
            handleClick={() =>  dispatch(updateCurrentPage('/dashboard/settings/company?view=genderConfig')) }
          />
          :
            <InlineMessage 
              key={'meow'}
              display={true}
              name={'publishermessage'}
              variant={'neutral'}
              icon={''}
              message={
              <Space alignItems={'center'}>
                <WarningIcon className='warningicon' /> Contact your Account Manager
              </Space>
              }
              close={false}
            />
        }
      </div>
      <PreviewConfig>
        <img src={`${url.image}/2.0/gender-options-preview.png`} alt="" width={200} height={218} />
      </PreviewConfig>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default GenderOptions;